export const LOYALTY_GET_ALL = "V1_LOYALTY_GET_ALL";